import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {Form} from 'react-bootstrap';

export type invertSelectionEvent = () => void

interface InvertSelectionProps {
    invertSelectionEvent : invertSelectionEvent
    checked? : boolean
}

export const InvertSelection = ({invertSelectionEvent, checked} : InvertSelectionProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    function fireInvertSelectionEvent()
    {
        if (invertSelectionEvent !== undefined) {
            invertSelectionEvent();
        }
    }

    return (
        <span className={"invert-selection btn btn-link p-0 align-bottom"} title={t("common.invert-selection")}>
            <Form.Check type="checkbox" checked={checked} onClick={fireInvertSelectionEvent} readOnly/>
        </span>
    )
}
